<div class="message-button-intent">
    <div class="button-group animated fadeIn">
        <ng-container *ngFor="let item of elements.payload.options">
            <button class="button" (click)="addMessage(item)">
                <img class="button-icon" *ngIf="item.image_url != undefined && item.image_url.length > 0" [src]="item.image_urlfeUrl">
                {{ item.title }}
            </button>
        </ng-container>
    </div>
</div>